// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"504":"chunk-vendors","524":"app"}[chunkId] || chunkId) + "." + {"231":"88719e89","504":"49223523","524":"766f37a0","671":"82abc732","692":"806f42e9","823":"df9a5ae5","870":"db576055"}[chunkId] + ".css";
};